import React, { useContext } from "react";
import BannerMob from "./banner-mob/BannerMob";
import BannerDest from "./banner-dest/BannerDest";

interface BannerProps {
    isMobile: boolean;
}

const Banner = ({ isMobile }: BannerProps) => {
    return <>{isMobile ? <BannerMob /> : <BannerDest />}</>;
};

export default Banner;
